import { Input, InputElement } from "../../../../common/components";
import { GetInputOptions } from "../getInput";
import React from "react";
import getTranslatedValue from "../../../../utils/CustomerTranslations/getTranslatedValue";
export const getDropdownInput = ({
  error,
  onChange,
  question,
  value,
  tCustomer
}: GetInputOptions) => {
  const {
    name,
    options,
    required
  } = question;
  const id = question.id ?? name;
  const label = getTranslatedValue(`customQuestion.${id}`, "name", tCustomer, question);

  // Shouldn't be possible, but just in case of bad data and mostly for TS
  if (typeof value === "boolean") throw new Error(`Type mismatch on value of question ${id}. Expected string, received boolean.`);
  if (!options) throw new Error(`No options found on dropdown-type question ${id}`);
  const onSelectOption = (event: React.ChangeEvent<InputElement>) => {
    const selectedIndex = event.target.selectedIndex;
    const options = event.target.options;
    const newValue = options[selectedIndex].text;
    onChange({
      id,
      newValue
    });
  };

  // Legacy options don't have ids (but also don't need them—they're only
  // used for sub question display on modern dropdowns), so just add value
  // as id in those cases to keep the behaviour uniform.
  const optionsWithId = options.map(({
    optionId,
    value
  }) => ({
    optionId: optionId ?? value,
    value
  }));
  return <Input variant="dropdown" id={id} onChange={onSelectOption} error={error} label={label} options={optionsWithId} required={required} selectedOption={value} data-sentry-element="Input" data-sentry-component="getDropdownInput" data-sentry-source-file="getDropdownInput.tsx" />;
};